import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "user-references"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TranslatedText = _resolveComponent("TranslatedText")!
  const _component_UserReferenceList = _resolveComponent("UserReferenceList")!

  return (_ctx.model)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("section", null, [
          _createElementVNode("h5", null, [
            _createVNode(_component_TranslatedText, { path: "references.employer-references" })
          ]),
          _createVNode(_component_UserReferenceList, {
            references: _ctx.employerReferences,
            referenceType: "employer",
            onSave: _ctx.handleSaveReference,
            onDelete: _ctx.handleDeleteReference
          }, null, 8, ["references", "onSave", "onDelete"])
        ]),
        _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
        _createElementVNode("section", null, [
          _createElementVNode("h5", null, [
            _createVNode(_component_TranslatedText, { path: "references.character-references" })
          ]),
          _createVNode(_component_UserReferenceList, {
            references: _ctx.characterReferences,
            referenceType: "character",
            onSave: _ctx.handleSaveReference,
            onDelete: _ctx.handleDeleteReference
          }, null, 8, ["references", "onSave", "onDelete"])
        ])
      ]))
    : _createCommentVNode("", true)
}